<template>
  <div class="product_combo-no-preview" v-if="product && showProductUpSell">
    <div
      class="product_combo-no-preview-button sib-button sib-button--default sib-button--md sib-button--width-default sib-button--round-md"
      @click="itemUpsell = !itemUpsell"
    >
      Add one more for your love - Save 5%
    </div>

    <ProductComboNoPreviewOptions
      class="product-upsell-options mt-sm"
      v-show="itemUpsell"
      :class="itemUpsell ? 'show' : 'off'"
      :productCombo="product"
      :customFieldName="'Enter Name (0|15) *'"
      @upsell-custom-field="updateCustomFieldUpsellProduct"
      @upsell-variant-selected="updateVariantSelectedUpsellProduct"
    />

    <div
      v-show="thisItem || itemUpsell"
      class="product_combo-no-preview-button sib-button sib-button--primary sib-button--md sib-button--width-default sib-button--round-md mt-sm"
      @click="addAllToCart"
    >
      <div v-if="loadingAddToCartCombo" class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span v-else> Add To Cart</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProductComboNoPreviewOptions from './ProductComboNoPreviewOptions.vue'
import { computed, ref, reactive, onMounted } from 'vue'
import useProductStore from '@/store/product'
import { CartLineItemInput } from '@/provider/type'
import { ProductVariant } from '@/types'
import useCartStore from '@/store/cart'
import EventBus from '@/services/eventbus'
import {
  EVENT_CUSTOMILY_DONE_LOADING,
  EVENT_ADD_TO_CART,
  EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW,
} from '@/utils'

const productStore = useProductStore()
const cartStore = useCartStore()

const thisItem = ref(true)
const itemUpsell = ref(false)
const loadingAddToCartCombo = ref(false)
const productUpsell = reactive({
  merchandiseId: '',
  quantity: 1,
  attributes: [],
})
const selectedVariantUpsellProduct = ref<ProductVariant | null>(null)

const productUpSellHandle =
  'nightmare-personalized-nightmare-accent-mug-12471023001scl1tmm1th06ha07an01acm1jak7028'

const product = computed(() => productStore.product)
const showProductUpSell = computed(
  () => productStore.product?.handle == productUpSellHandle
)

function updateCustomFieldUpsellProduct(customField: string) {
  productUpsell.attributes = [{ key: 'Enter Name', value: customField }] as any
}
function updateVariantSelectedUpsellProduct(variantSelected: any) {
  selectedVariantUpsellProduct.value = variantSelected
  productUpsell.merchandiseId = variantSelected.id
}

onMounted(() => {
  EventBus.on(EVENT_CUSTOMILY_DONE_LOADING, () => {
    if (showProductUpSell.value) {
      const buttonGroup = document.querySelector(
        '.product__button-group'
      ) as HTMLButtonElement

      if (buttonGroup) {
        buttonGroup.style.display = 'none'
      }
    }
  })
  EventBus.on(EVENT_ADD_TO_CART, () => {
    loadingAddToCartCombo.value = false
  })
  EventBus.on(EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW, () => {
    loadingAddToCartCombo.value = true
    setTimeout(() => {
      loadingAddToCartCombo.value = false
    }, 5000)
  })
})

async function addAllToCart() {
  if (
    itemUpsell.value &&
    (!productUpsell.merchandiseId || !productUpsell.attributes[0]?.value)
  ) {
    EventBus.trigger('require-field-upsell', true)
    return
  }

  loadingAddToCartCombo.value = true
  if (!itemUpsell.value) {
    const addToCartButton = document.querySelector(
      '.product__button-group .product__add-to-cart-button'
    ) as HTMLButtonElement

    if (addToCartButton) addToCartButton.click()
  } else {
    await addToCartUpsellProduct()

    const addToCartButton = document.querySelector(
      '.product__button-group .product__add-to-cart-button'
    ) as HTMLButtonElement
    if (addToCartButton) addToCartButton.click()
  }
  setTimeout(() => {
    loadingAddToCartCombo.value = false
  }, 5000)
}

async function addToCartUpsellProduct() {
  if (!productUpsell.merchandiseId || !productUpsell.attributes[0]?.value) {
    return
  }
  const lineItem: CartLineItemInput = productUpsell
  await cartStore.addToCart(lineItem)
}
</script>

<style lang="scss" scoped>
.product_combo-no-preview {
  width: 100%;
  margin: 2rem 0 1rem;

  .product-upsell-options {
    border: 1px solid var(--border-color);
    padding: 1rem;
    margin-top: 1rem;
    border-radius: 3px;
    &.show {
      height: unset;
      transition: max-height 0.25s ease-in;
    }
    &.off {
      height: 0;
      transition: max-height 0.15s ease-out;
      overflow: hidden;
    }
  }

  .lds-ring {
    --loading-size: 15px;
    --loading-line-width: 2px;
    color: #ffffff;
    top: 50%;
    transform: translate(-50%, -67%);
    z-index: 2;
  }

  .product_combo-no-preview-button {
    line-height: 1;
  }
  @include media-md-up {
    .product_combo-no-preview-button {
      max-width: 300px;
    }
  }
}
</style>
